module.exports = __webpack_public_path__ + "img/case_rog.1022aa5c.jpg";